import React from "react"
import {tt} from "@lib/helpers"
import {isEmpty} from "lodash"

type PropTypes = {
  stauts: string
  t: RailsI18n.T
}

const AdminPublishersStatus: React.FC<PropTypes> = ({status, t}) => {
  const __formRef = React.useRef()

  return (
    <div className="Filter">
      <form className="Filter__form" ref={__formRef}>
        <div className="Filter__form__label">
          <span className="Filter__form__label__span">{tt(t, "status")}</span>
          <div className="Filter__form__label__input">
            <div className="Filter__form__label__input__checkboxes">
              <label className="CheckBox">
                <input
                  type="radio"
                  name="status"
                  defaultValue="all"
                  defaultChecked={status == "all"}
                  onChange={(e) => {
                    e.preventDefault()
                    __formRef.current.submit()
                  }}
                />
                <div className="CheckBox__span">{tt(t, "filter.all")}</div>
              </label>
              <label className="CheckBox">
                <input
                  type="radio"
                  name="status"
                  defaultValue="kept"
                  defaultChecked={status == "kept" || isEmpty(status)}
                  onChange={(e) => {
                    e.preventDefault()
                    __formRef.current.submit()
                  }}
                />
                <div className="CheckBox__span">{tt(t, "filter.kept")}</div>
              </label>
              <label className="CheckBox">
                <input
                  type="radio"
                  name="status"
                  defaultValue="discarded"
                  defaultChecked={status == "discarded"}
                  onChange={(e) => {
                    e.preventDefault()
                    __formRef.current.submit()
                  }}
                />
                <div className="CheckBox__span">
                  {tt(t, "filter.discarded")}
                </div>
              </label>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default AdminPublishersStatus
